<template lang="pug">
    div
        template(v-if="$store.state.queryGroupName == 'all'")
            Card
                div(style="text-align: center")
                    h3 Please choose a group to manage group api keys.
        template(v-else)
            Card.a8-page-description-card
                Row(type="flex" align="middle" justify="space-between")
                    Col
                        h2 {{$t('apiKeys.pageTitleText')}}
                    Col
                        ExplainBtn(:objectExplanation="objectsExplanation")
                p Manage group api keys.
            Card
                Row(justify="space-between" align="middle")
                    div(style="display: flex; flex-direction: row; align-items: center;padding: 0 15px")
                        Icon(type="md-alert" size="24")
                        pre {{$t('apiKeys.hintText')}}
                    Button(
                        v-if="hasChanged"
                        :type="$can('write', 'groupResourcesPermission','ApiKeys')?'primary':'default'"
                        @click="updateApiKeys" :disabled="!$can('write', 'groupResourcesPermission','ApiKeys')"
                        ) {{ $t("rcmtable.saveText") }}
                div(v-for="item in apiKeysItems")
                    pre.title(slot="title") {{item.name}}
                    p.description(v-if="item.key=='groupVaptcha'") We use VAPTCHA for gesture challenge, for more information, please look at
                        a(v-if="item.key=='groupVaptcha'" href="https://www.vaptcha.com/")  VAPTCHA
                    Form(:label-width="80" label-position="left")
                        FormItem(label="ID")
                            Input(v-model="apiKeysData[item.key].id" :placeholder="`${$t('apiKeys.placeholder')} Api ID`" :disabled="apiKeysData[item.key].disable||!$can('write', 'groupResourcesPermission','ApiKeys')")
                        FormItem(label="KEY")
                            Input(v-model="apiKeysData[item.key].key" :placeholder="`${$t('apiKeys.placeholder')} Api KEY`" :disabled="apiKeysData[item.key].disable||!$can('write', 'groupResourcesPermission','ApiKeys')")
</template>
<script>
import Vue from "vue";
import bus from "@/libs/bus.js";

import { getGroupApiKeys, updateGroupApiKeys } from "@/api/groupasset.js";

export default {
    name: "GroupResource",
    data() {
        return {
            esIndex: "api-keys",
            apiKeysItems: [
                {
                    key: "groupVaptcha",
                    name: this.$i18n.t("apiKeys.vaptcha"),
                    value: { id: "", key: "", disable: false },
                },
                {
                    key: "groupCaptcha",
                    name: this.$i18n.t("apiKeys.captcha"),
                    value: { id: "", key: "", disable: false },
                },
            ],
            apiKeysData: {
                groupVaptcha: {
                    id: "",
                    key: "",
                    disable: false,
                },
                groupCaptcha: {
                    id: "",
                    key: "",
                    disable: false,
                },
            },
            originApiKeysData: null,
            objectsExplanation: {},
        };
    },
    computed: {
        hasChanged() {
            return JSON.stringify(this.apiKeysData) !== JSON.stringify(this.originApiKeysData);
        },
    },
    watch: {
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            },
        },
    },
    methods: {
        getData() {
            getGroupApiKeys({
                groupName: [this.$store.state.queryGroupName],
            })
                .then((res) => {
                    this.apiKeysData = res.data;
                    for (var key in this.apiKeysData) {
                        this.apiKeysItems.forEach((item) => {
                            if (item.key == key) {
                                item.value = this.apiKeysData[key];
                            }
                        });
                    }

                    for (var key in this.apiKeysData) {
                        this.apiKeysItems.forEach((item) => {
                            if (item.key == "groupCaptcha") {
                                item.value.disable = true;
                            } else {
                                item.value.disable = false;
                            }
                        });
                    }

                    this.originApiKeysData = JSON.parse(JSON.stringify(this.apiKeysData));
                })
                .catch((err) => {
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${err.message}`,
                    });
                });
        },
        updateApiKeys() {
            updateGroupApiKeys({
                groupName: [this.$store.state.queryGroupName],
                data: this.apiKeysData,
            })
                .then((res) => {
                    this.$Notice.success({
                        title: this.$t("global.success"),
                        desc: `${res.data.message}`,
                    });
                    this.getData();
                })
                .catch((err) => {
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${err.message}`,
                    });
                });
        },
    },
    mounted() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
    },
    created() {
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
        this.getData();
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>
<style lang="less" scoped>
.title {
    font-size: 16px;
    font-weight: bold;
}
.description {
    padding-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/ApiKeys/Page.vue